import React from 'react'
import HomeBanner from '../components/HomeBanner'
import styled from 'styled-components'
import CompanyLogos from '../components/CompanyLogos'
import Web2Services from '../components/Web2Services';
import DifferentClient from '../components/DifferentClient';
import ProcessSection from '../components/ProcessSection';
import ClientSuccessSection from '../components/ClientSuccessSection';
import ContactSection from '../components/ContactSection';
const Homewrapper = styled.div`
    width: 100%;
    height: 100%;
    // padding: 2rem 0rem;
    box-sizing: border-box;
`

const Home = () => {
  return (
    <Homewrapper>
        <HomeBanner />
        <CompanyLogos />
        <DifferentClient />
        <ProcessSection />
        <ClientSuccessSection />
        <ContactSection />
    </Homewrapper>

  )
}

export default Home